import type { IconSets } from "@toruslabs/vue-components";
import { createIcons } from "@toruslabs/vue-components/icons";

const Icons = {
  XSolidIcon: () => import("@toruslabs/vue-icons/notifications/XSolidIcon"),
  XCircleSolidIcon: () => import("@toruslabs/vue-icons/notifications/XCircleSolidIcon"),
  InformationCircleIcon: () => import("@toruslabs/vue-icons/security/InformationCircleIcon"),
  CheckCircleSolidIcon: () => import("@toruslabs/vue-icons/notifications/CheckCircleSolidIcon"),
  DocumentDuplicateIcon: () => import("@toruslabs/vue-icons/file/DocumentDuplicateIcon"),
} as unknown as IconSets;

export default createIcons(Icons);
